import { css } from '@emotion/css';

const wrapper = css({
  position: 'relative',
  maxWidth: '100%',

  '.MuiTabs-indicator': {
    backgroundColor: 'var(--colors-primary-500)',
  },
});

const tabElement = css({
  '&.MuiTab-root': {
    color: 'var(--colors-neutral-400)',
    fontWeight: 'normal',
    textTransform: 'none',
    marginRight: '8px',

    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '2px',
      backgroundColor: 'var(--colors-neutral-200)',
    },

    '&.Mui-selected': {
      color: 'var(--colors-primary-900)',
      fontWeight: 'bold',
    },
  },
});

const mobileTabElement = css({
  '.MuiTabs-flexContainer': {
    borderBottom: '2px solid var(--colors-neutral-200)',
  },

  '.MuiTabs-indicator': {
    bottom: '1px',
  },

  '&.MuiTabs-root': {
    height: '3px',
    minHeight: 'unset',

    '.MuiTab-root': {
      flex: 1,
      padding: '0px',
      height: '0px',
      minHeight: 'unset',

      '&:last-child': {
        marginRight: 0,
      },
    },
  },
});

const TabsEfexStyles = {
  wrapper,
  tabElement,
  mobileTabElement,
};

export default TabsEfexStyles;
